import React, { useEffect, useState } from "react";
import { ChevronRight, ChevronLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetMortgageShareApplicationQuery } from "@/store/service";
import MortgageShareCompleteForm from "@/model/interface/MortgageShareCompleteForm";
import { useForm } from "react-hook-form";
import MortgageShareFlowTopTabs from "./MortgageShareFlowTopTabs";
import PreviewStep from "./PreviewStep";

export const StepTypes = [
  "preview",
  "applicant",
  "liabilities",
  "assets",
  "banking-details",
  "review",
  "success",
] as const;
export type StepTypes = (typeof StepTypes)[number];

const MortgageShareFlow = () => {
  const params = useParams();
  const [step, setStep] = useState<StepTypes>("preview");
  const { data, isError } = useGetMortgageShareApplicationQuery(params.id!);
  const navigate = useNavigate();

  const form = useForm<MortgageShareCompleteForm>({
    mode: "all",
    defaultValues: {},
  });

  useEffect(() => {
    if (isError) {
      navigate("/dashboard");
    }
  }, [isError]);

  const onSubmit = (data: MortgageShareCompleteForm) => {};

  const advanceStep = () => {
    if (step === "preview") {
      setStep("applicant");
    }

    if (step === "applicant") {
      if (!form.getFieldState("applicant.emailAddress").invalid) {
        form
          .trigger(["applicant.firstName", "applicant.lastName", "applicant.emailAddress", "applicant.phone"], {
            shouldFocus: true,
          })
          .then((res) => {
            if (res) {
              setStep("liabilities");
            }
          });
      }
    }

    if (step === "preview") {
      onSubmit(form.getValues());
    }
  };

  const reverseStep = () => {
    if (step === "applicant") {
      setStep("preview");
    }

    if (step === "liabilities") {
      setStep("applicant");
    }

    if (step === "assets") {
      setStep("liabilities");
    }

    if (step === "banking-details") {
      setStep("assets");
    }
  };

  if (!data) {
    return <></>;
  }

  return (
    <div className="flex flex-col flex-1">
      <section className="relative text-center py-20 text-[#010305]">
        <div className="max-w-[1200px] mx-auto px-4">
          <h2>Fintree mortgage share</h2>
        </div>
      </section>
      <section className="relative pt-0 pb-16 bg-[#f0f5fb]">
        <div className="max-w-[1200px] mx-auto px-4">
          <div className="relative w-full flex justify-center items-center ">
            <div className="relative w-full">
              <div className="edit-profile-info-tabs">
                <div className="relative tabs-box">
                  <MortgageShareFlowTopTabs step={step} setStep={setStep} />
                  <div className="tabs-content">
                    <form onSubmit={form.handleSubmit(onSubmit)}>
                      <div className={`tab ${step === "preview" ? "active-tab" : ""}`} id="prod-overview">
                        <PreviewStep mortgageShareApplication={data} />
                      </div>

                      <div className={`tab ${step === "applicant" ? "active-tab" : ""}`} id="prod-company">
                        {/*<ApplicantFormStep form={form} mortgageShareApplication={data}/>*/}
                      </div>

                      <div className={`tab ${step === "liabilities" ? "active-tab" : ""}`} id="prod-personal">
                        <div className="content"></div>
                      </div>

                      <div className={`tab ${step === "success" ? "active-tab" : ""}`} id="prod-personal">
                        <div className="content">
                          <div>
                            <div className="flex flex-wrap text-center">
                              <h3>Success!</h3>
                            </div>
                            <br />
                            <br />
                            <div>
                              <p>
                                We have securely saved your information. One of our representatives will contact you
                                soon.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center items-center text-center flex flex-wrap">
                        <div className="get-started-button-box">
                          {step !== "preview" && step !== "success" && (
                            <a
                              className="inline-block text-base leading-[30px] text-[#010305] py-2.5 px-11 rounded-full bg-[#9BFBE0] capitalize shadow-sm hover:opacity-80 transition-all"
                              onClick={reverseStep}
                            >
                              <span className="txt">
                                Back
                                <ChevronLeft className="inline size-4" />
                              </span>
                            </a>
                          )}
                          {step !== "success" && (
                            <a
                              className="inline-block text-base leading-[30px] text-[#010305] py-2.5 px-11 rounded-full bg-[#9BFBE0] capitalize shadow-sm hover:opacity-80 transition-all"
                              onClick={advanceStep}
                            >
                              <span className="txt">
                                {step !== "review" ? "Next" : "Submit"}
                                <ChevronRight className="inline size-4" />
                              </span>
                            </a>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

MortgageShareFlow.propTypes = {};

export default MortgageShareFlow;
